import type { ReactNode } from 'react';
import useLocalStorageState from 'use-local-storage-state';

import { theme } from '@adflow/frontend/ui-theme';

import type { DataTableProps } from '../DataTable';
import { DataTable } from '../DataTable';

import { SidebarToggle } from './SidebarToggle';

type SidebarTableProps<T> = DataTableProps<T> & {
	header: ReactNode;
	content: ReactNode;
};

export function SidebarTable<T>({
	header,
	content,
	...dataTableProps
}: SidebarTableProps<T>) {
	const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorageState<boolean>(
		'sidebar-table-collapsed',
		{ defaultValue: true }
	);

	return (
		<div
			css={{
				position: 'relative',
				display: 'flex',
				flexGrow: '1',
				flexShrink: '1',
				minHeight: '0px',
				height: '100%',
			}}
		>
			<DataTable
				{...dataTableProps}
				header={header}
				sidebarStyle
				sidebarCollapsed={sidebarCollapsed}
				onlySticky
			/>
			<main
				css={{
					backgroundColor: theme.colors.background.form,
					flexGrow: 1,
					position: 'relative',
				}}
			>
				<SidebarToggle
					sidebarCollapsed={sidebarCollapsed}
					setSidebarCollapsed={setSidebarCollapsed}
				/>
				{content}
			</main>
		</div>
	);
}
